<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      <StatCard label="จำนวนเด็ก NEETs ทั้งหมด" :value="totalNeet" unit="คน" align="left" >
        <template #icon>
          <div class="w-6 h-6">
            <PeopleIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="สัดส่วนเทียบกับเด็กในช่วงอายุเดียวกัน" :value="neetRatioPct" align="left" >
        <template #icon>
          <div class="w-6 h-6">
            <SingleUserIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="ต้องการเรียน/ทำงานต่อ" :value="wantFuturePct" align="left" >
        <template #icon>
          <div class="w-6 h-6">
            <EducationIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
      <StatCard label="เคยถูกละเมิด/ทำร้าย" :value="violatePct" align="left" >
        <template #icon>
          <div class="w-6 h-6">
            <HandIcon class="w-full h-full" />
          </div>
        </template>
      </StatCard>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="เพศและอายุ" class="h-full">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            <StatCard label="หญิง" :value="femaleCount" unit="คน" align="left" />
            <StatCard label="ชาย" :value="maleCount" unit="คน" align="left" />
          </div>
          <!-- <div class="flex items-center justify-between bg-gray-50 rounded-lg px-4 py-3 mb-4">
            <div>
              <div class="text-2xl font-bold text-primary-1">58%</div>
              <div class="text-xs text-gray-500">หญิง (199 คน)</div>
            </div>
            <div class="text-right">
              <div class="text-2xl font-bold text-gray-400">42%</div>
              <div class="text-xs text-gray-500">ชาย (143 คน)</div>
            </div>
          </div> -->
          <div class="min-h-[350px]">
            <ProgressList :items="ageGroups" :color="A.navy" minHeight="350px" />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="ระดับการศึกษาสูงสุด" class="h-full">
          <div class="h-[400px]">
            <ChartWithLegend
              chart-id="nEduChart"
              :series="edu.series"
              :labels="edu.labels"
              unit="คน"
              :show-data-label="true"
              legendLayout="horizontal"
              :palette="eduPalette"
            />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="ความต้องการ/ความคาดหวังในอนาคต" class="h-full">
          <div class="h-[400px]">
            <ChartWithLegend
              chart-id="nAspirationChart"
              :series="aspiration.series"
              :labels="aspiration.labels"
              unit="คน"
              :show-data-label="true"
              legendLayout="horizontal"
              :palette="['#3A506A', '#F4D35E', '#11D67A', '#20A0D7', '#AF52DE']"
            />
          </div>
        </ChartCard>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-7">
        <ChartCard title="ความช่วยเหลือหรือการสนับสนุนที่ต้องการ" class="h-full">
          <div class="h-[400px]">
            <DashboardBarEChart chart-id="nSupportChart" type="bar" :data="supportData" :options="hOptions(1.5, true)" fill-height />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-5">
        <ChartCard title="ปัจจัยเสี่ยง" class="h-full">
          <div class="min-h-[400px]">
            <ProgressList :items="riskProfile" :color="A.yellow" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="อุปสรรค/ข้อจำกัด" class="h-full">
          <div class="h-[400px]">
            <DashboardBarEChart chart-id="nBarrierChart" type="bar" :data="barrierData" :options="hOptions(2.2, true)" fill-height />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="ประสบการณ์การทำงานในอดีต" class="h-full">
          <div class="h-[400px]">
            <ChartWithLegend
              chart-id="nWorkExpChart"
              :series="workExp.series"
              :labels="workExp.labels"
              unit="คน"
              :show-data-label="true"
              legendLayout="horizontal"
              :palette="workExpPalette"
            />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="สาเหตุที่ไม่ได้ทำงานแล้ว" class="h-full">
          <div class="min-h-[400px]">
            <ProgressList :items="quitReasons" :color="A.yellow" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="ลักษณะงานที่เคยทำ" class="h-full">
          <div class="min-h-[400px]">
            <ProgressList :items="jobTypeList" :color="A.yellow" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="ผู้ที่อาศัยอยู่ด้วย" class="h-full">
          <div class="h-[400px]">
            <ChartWithLegend
              chart-id="nLivingChart"
              :series="living.series"
              :labels="living.labels"
              unit="คน"
              :show-data-label="true"
              legendLayout="horizontal"
              :palette="livingPalette"
            />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="เหตุผลที่ไม่ได้อยู่กับพ่อ และ/หรือ แม่" class="h-full">
          <div class="h-[400px]">
            <ProgressList :items="reasonList" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="หน้าที่ หรือความรับผิดชอบในครัวเรือน" class="h-full">
          <div class="min-h-[400px]">
            <ProgressList :items="duties" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="ทัศนคติพ่อแม่/ผู้ปกครองต่อการศึกษา" class="h-full">
          <div class="h-[400px]">
            <DashboardBarEChart chart-id="nAttitudeChart" type="bar" :data="attitudeData" :options="attitudeOptions" fill-height />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-4">
        <ChartCard title="แนะแนวจากโรงเรียน" class="h-full">
          <div class="min-h-[400px]">
            <ProgressList :items="guidance" :color="A.yellow" minHeight="400px" />
          </div>
        </ChartCard>
      </div>
    </div>

    <div class="mt-6">
      <ChartCard title="ประสบการณ์การตั้งครรภ์ในวัยรุ่น">
        <div class="grid grid-cols-12 gap-6">
          <div class="col-span-12 lg:col-span-3 flex flex-col gap-4">
            <StatCard label="มีประสบการณ์" :value="`${pregnancyExperiencePct}%`"  align="center" />
            <StatCard label="ไม่มีประสบการณ์" :value="`${pregnancyNoPct}%`"  align="center" />
          </div>
          <div class="col-span-12 lg:col-span-5">
            <p class="text-sm font-semibold text-gray-700 mb-4">ผู้ทำหน้าที่ดูแลบุตรเป็นหลัก</p>
            <div class="min-h-[300px]">
              <ProgressList :items="caregiver" :color="A.yellow" minHeight="300px" />
            </div>
          </div>
          <div class="col-span-12 lg:col-span-4">
            <p class="text-sm font-semibold text-gray-700 mb-4">แหล่งค่าใช้จ่ายเลี้ยงดูบุตร</p>
            <div class="min-h-[300px]">
              <ProgressList :items="childCost" :color="A.yellow" minHeight="300px" />
            </div>
          </div>
        </div>
      </ChartCard>
    </div>


    <div class="grid grid-cols-12 gap-6 mt-6">
      <div class="col-span-12 lg:col-span-7">
        <ChartCard title="กิจกรรมที่ชอบทำยามว่าง">
          <div class="h-[400px]">
            <DashboardBarEChart chart-id="nLeisureChart" type="bar" :data="leisureData" :options="hOptions(2)" fill-height />
          </div>
        </ChartCard>
      </div>
      <div class="col-span-12 lg:col-span-5">
        <ChartCard title="ระดับที่ต้องการเรียน/ศึกษาต่อ">
          <div class="h-[400px]">
            <ChartWithLegend
              chart-id="nStudyLevelChart"
              :series="studyLevel.series"
              :labels="studyLevel.labels"
              unit="คน"
              :show-data-label="true"
              legendLayout="horizontal"
              :palette="['#3A506A', '#F4D35E', '#11D67A', '#20A0D7', '#AF52DE']"
            />
          </div>
        </ChartCard>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { globalNumDecFixed } from "@/utils/format-number.js";
import ChartCard from "../container/ChartCard.vue";
import ChartWithLegend from "../container/ChartWithLegend.vue";
import ProgressList from "../container/ProgressList.vue";
import DashboardBarEChart from "../container/DashboardBarEChart.vue";
import StatCard from "../container/StatCard.vue";

const A = { navy: "#3A506A", yellow: "#F4D35E", green: "#11D67A", blue: "#20A0D7", purple: "#AF52DE", gray: "#606468", red: "#F73C4B" };

const bar = (label, color, data, opts = {}) => ({
  label, backgroundColor: color, data, barPercentage: 0.6, categoryPercentage: 0.8, ...opts,
});

const wrapLabelOnNarrowChart = function (value) {
  const label = this.getLabelForValue(value);
  if (typeof label !== "string" || this.chart.width >= 480 || label.length <= 14) return label;
  return `${label.slice(0, 14).trim()}...`;
};

const barOptions = ({ legend = false, stacked = false, horizontal = false, aspectRatio = 2, wrapYLabels = false } = {}) => {
  const cat = {
    stacked,
    grid: { display: false },
    ticks: {
      font: { size: 12 },
      autoSkip: false,
      maxRotation: horizontal ? 0 : 45,
      minRotation: horizontal ? 0 : 45,
      ...(horizontal && wrapYLabels ? { callback: wrapLabelOnNarrowChart } : {}),
    },
  };
  const val = { stacked, beginAtZero: true, grid: { color: "#E2E8F0" }, ticks: { font: { size: 12 }, precision: 0 } };
  return {
    indexAxis: horizontal ? "y" : "x",
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio,
    plugins: {
      legend: { display: legend, position: "bottom", labels: { usePointStyle: true, boxWidth: 8, font: { size: 12 } } },
      tooltip: {
        enabled: true,
        callbacks: {
          label(ctx) {
            const numVal = horizontal ? ctx.parsed.x : ctx.parsed.y;
            return `${ctx.dataset.label}: ${globalNumDecFixed(numVal)} คน`;
          },
        },
      },
    },
    scales: horizontal ? { x: val, y: cat } : { x: cat, y: val },
  };
};

const hOptions = (aspectRatio, wrapYLabels = false) => barOptions({ horizontal: true, aspectRatio, wrapYLabels });
const hbar = (labels, data) => ({
  labels,
  datasets: [bar("จำนวน", A.navy, data, { barPercentage: 0.7, categoryPercentage: 0.8 })],
});

const LEISURE_ORDER = [
  "ท่องโลกโซเชียล (เฟซบุ๊ก อินสตาแกรม กูเกิล ทวิตเตอร์ ติ๊กต็อก) ",
  "ดูยูทูบ/ดูสตรีมเมอร์",
  "เล่นเกม",
  "ดูโทรทัศน์",
  "เล่นกีฬา",
  "อื่น ๆ",
  "เล่นดนตรี",
];
const LEISURE_DISPLAY_BY_LABEL = {
  "ท่องโลกโซเชียล (เฟซบุ๊ก อินสตาแกรม กูเกิล ทวิตเตอร์ ติ๊กต็อก) ": "ท่องโซเชียลมีเดีย",
  "ดูยูทูบ/ดูสตรีมเมอร์": "ดูยูทูบ/สตรีมเมอร์",
  "เล่นเกม": "เล่นเกม",
  "ดูโทรทัศน์": "ดูโทรทัศน์",
  "เล่นกีฬา": "เล่นกีฬา",
  "อื่น ๆ": "อื่น ๆ",
  "เล่นดนตรี": "เล่นดนตรี",
};
const LEISURE_COLOR_BY_LABEL = {
  "ท่องโลกโซเชียล (เฟซบุ๊ก อินสตาแกรม กูเกิล ทวิตเตอร์ ติ๊กต็อก) ": "#5C7A99",
  "ดูยูทูบ/ดูสตรีมเมอร์": "#A65B3F",
  "เล่นเกม": "#7C5C7A",
  "ดูโทรทัศน์": "#C99A3D",
  "เล่นกีฬา": "#4A7A78",
  "อื่น ๆ": "#8E4B5C",
  "เล่นดนตรี": "#7A8C4A",
};

const withColors = (items) => items.map((it) => ({ ...it, color: A.navy }));
const store = useStore();
const filterParams = computed(() => store.getters["dashboardOverviewFilter/getFilterForApiNeets"]);
const authHeaders = () => ({
  Authorization: `Bearer ${store.getters["userAuth/getToken"]}`,
  "Content-Type": "application/json",
});
const apiGet = (path) =>
  axios.get(`${process.env.VUE_APP_BASE_API}${path}`, {
    headers: authHeaders(),
    params: filterParams.value,
  }).catch((err) => err);

const toNumber = (value) => Number(value || 0);
const toPercent = (v) => `${(v || 0)}%`;
const makeProgressItems = (items) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    label: item?.value ?? "",
    percent: toNumber(item?.pct),
    value: toNumber(item?.count ?? 0),
  }));
};

const ATTITUDE_LEVEL_COLOR = { "น้อย": "#F73C4B", "ปานกลาง": "#FE9000", "มาก": "#11D67A" };
const buildAttitudeData = (educationItems, scoreItems) => {
  const labels = (Array.isArray(educationItems) ? educationItems : []).slice(0, 2).map((item) => item?.value ?? "");
  const values = (Array.isArray(scoreItems) && scoreItems.length ? scoreItems : (Array.isArray(educationItems) ? educationItems : [])).slice(0, labels.length || 2).map((item) => toNumber(item?.count ?? 0));
  return {
    labels: labels.map((label) => [label]),
    datasets: [bar("จำนวน", labels.map((label) => ATTITUDE_LEVEL_COLOR[label] || A.navy), values)],
  };
};

const totalNeet = ref(0);
const neetRatioPct = ref("0%");
const wantFuturePct = ref("0%");
const violatePct = ref("0%");
const femaleCount = ref(0);
const maleCount = ref(0);

const ageGroups = ref([]);
const edu = ref({ labels: [], series: [] });
const EDU_NEVER_STUDIED_LABEL = "ไม่เคยเรียน";
const EDU_THEME_PALETTE = ["#345E7E", "#2CA6BD", "#2FAE7E", "#E0A64A", "#8B6BC2", "#D97D3D", "#6B7280"];
const eduPalette = computed(() => {
  let themeIdx = 0;
  return edu.value.labels.map((label) => {
    if (label === EDU_NEVER_STUDIED_LABEL) return "#F73C4B";
    const color = EDU_THEME_PALETTE[themeIdx % EDU_THEME_PALETTE.length];
    themeIdx++;
    return color;
  });
});
const aspiration = ref({ labels: [], series: [] });

const supportData = ref({ labels: [], datasets: [] });
const riskProfile = ref([]);
const barrierData = ref({ labels: [], datasets: [] });
const workExp = ref({ labels: [], series: [] });
const WORK_EXP_NEVER_WORKED_LABEL = "ไม่เคยทำงาน";
const WORK_EXP_THEME_PALETTE = ["#11D67A", "#F4D35E", "#3A506A", "#20A0D7", "#AF52DE", "#FE9000", "#606468"];
const workExpPalette = computed(() => {
  let themeIdx = 0;
  return workExp.value.labels.map((label) => {
    if (label === WORK_EXP_NEVER_WORKED_LABEL) return "#F73C4B";
    const color = WORK_EXP_THEME_PALETTE[themeIdx % WORK_EXP_THEME_PALETTE.length];
    themeIdx++;
    return color;
  });
});
const quitReasons = ref([]);

const living = ref({ labels: [], series: [] });
const LIVING_COLOR_BY_LABEL = {
  "อยู่กับทั้งพ่อและแม่": "#345E7E",
  "อยู่กับแม่คนเดียว": "#2CA6BD",
  "อยู่กับพ่อคนเดียว": "#2FAE7E",
  "อยู่กับปู่ ย่า ตา และ/หรือ ยาย": "#E0A64A",
  "อยู่กับญาติอื่น ๆ": "#8B6BC2",
  "อยู่กับคนอื่น": "#6B7280",
};
const livingPalette = computed(() =>
  living.value.labels.map((label) => LIVING_COLOR_BY_LABEL[label] || "#606468")
);
const reasonList = ref([]);
const duties = ref([]);
const attitudeData = ref({ labels: [], datasets: [] });
const guidance = ref([]);
const jobTypeList = ref([]);
const caregiver = ref([]);
const childCost = ref([]);
const leisureData = ref({ labels: [], datasets: [] });
const studyLevel = ref({ labels: [], series: [] });

const pregnancyExperiencePct = ref(0);
const pregnancyNoPct = ref(0);

const fetchOverview = async () => {
  const res = await apiGet(`neetSurveys/dashboard/overview`);
  if (res?.status === 200) {
    const data = res.data || {};

    totalNeet.value = toNumber(data.total_neet ?? data.total ?? 0);
    neetRatioPct.value = toPercent(data.neet_ratio_pct ?? 0);
    wantFuturePct.value = toPercent(data.want_future_pct ?? 0);
    violatePct.value = toPercent(data.violate_pct ?? 0);
    pregnancyExperiencePct.value = toNumber(data.early_pregnant_pct ?? 0);
    pregnancyNoPct.value = toNumber(data.no_pregnant_pct ?? 0);

    const byGender = Array.isArray(data.by_gender) ? data.by_gender : [];
    const female = byGender.find((item) => ["หญิง", "เพศหญิง", "female"].includes(String(item?.gender || "")));
    const male = byGender.find((item) => ["ชาย", "เพศชาย", "male"].includes(String(item?.gender || "")));
    femaleCount.value = toNumber(female?.total ?? female?.count ?? 0);
    maleCount.value = toNumber(male?.total ?? male?.count ?? 0);

    ageGroups.value = (Array.isArray(data.by_age_group) ? data.by_age_group : []).map((item) => ({
      label: item?.age_group ?? "",
      percent: toNumber(item?.pct),
      value: toNumber(item?.count ?? 0),
    }));

    const eduItems = Array.isArray(data.by_education_level) ? data.by_education_level : [];
    edu.value = {
      labels: eduItems.map((item) => item?.level ?? ""),
      series: eduItems.map((item) => toNumber(item?.count ?? 0)),
    };

    const futureItems = Array.isArray(data.future_expect) ? data.future_expect : [];
    aspiration.value = {
      labels: futureItems.map((item) => item?.value ?? ""),
      series: futureItems.map((item) => toNumber(item?.count ?? 0)),
    };
  }
};

const fetchRiskSupport = async () => {
  const res = await apiGet(`neetSurveys/dashboard/riskSupport`);
  if (res?.status === 200) {
    const data = res.data || {};

    const helpItems = Array.isArray(data.help_needed) ? data.help_needed : [];
    supportData.value = hbar(
      helpItems.map((item) => item?.value ?? ""),
      helpItems.map((item) => toNumber(item?.count ?? 0))
    );

    const riskItems = Array.isArray(data.risk_factors) ? data.risk_factors : [];
    riskProfile.value = riskItems.map((item) => ({
      label: item?.value ?? "",
      percent: toNumber(item?.pct),
      value: toNumber(item?.count ?? 0),
    }));

    const obstacleItems = Array.isArray(data.obstacles) ? data.obstacles : [];
    barrierData.value = hbar(
      obstacleItems.map((item) => item?.value ?? ""),
      obstacleItems.map((item) => toNumber(item?.count ?? 0))
    );

    const workItems = Array.isArray(data.work_experience) ? data.work_experience : [];
    workExp.value = {
      labels: workItems.map((item) => item?.value ?? ""),
      series: workItems.map((item) => toNumber(item?.count ?? 0)),
    };

    quitReasons.value = makeProgressItems(Array.isArray(data.no_work_reason) ? data.no_work_reason : []);
  }
};

const fetchFamily = async () => {
  const res = await apiGet(`neetSurveys/dashboard/family`);
  if (res?.status === 200) {
    const data = res.data || {};
    const livingItems = Array.isArray(data.living) ? data.living : [];
    living.value = {
      labels: livingItems.map((item) => item?.value ?? ""),
      series: livingItems.map((item) => toNumber(item?.count ?? 0)),
    };

    reasonList.value = makeProgressItems(Array.isArray(data.reason_not_with_parent) ? data.reason_not_with_parent : []);
    duties.value = withColors(makeProgressItems(Array.isArray(data.responsible) ? data.responsible : []));
    guidance.value = makeProgressItems(Array.isArray(data.guidance) ? data.guidance : []);
    jobTypeList.value = makeProgressItems(Array.isArray(data.work_type) ? data.work_type : []);
    attitudeData.value = buildAttitudeData(
      Array.isArray(data.parent_education_attitude) ? data.parent_education_attitude : [],
      Array.isArray(data.parent_score_attitude) ? data.parent_score_attitude : []
    );
  }
};

const fetchFuture = async () => {
  const res = await apiGet(`neetSurveys/dashboard/future`);
  if (res?.status === 200) {
    const data = res.data || {};
    pregnancyExperiencePct.value = toNumber(data.early_pregnant_pct ?? 0);
    pregnancyNoPct.value = toNumber(data.no_pregnant_pct ?? 0);
    caregiver.value = makeProgressItems(Array.isArray(data.child_care) ? data.child_care : []);
    childCost.value = makeProgressItems(Array.isArray(data.child_care_allowance) ? data.child_care_allowance : []);

    const hobbyItems = Array.isArray(data.hobby) ? data.hobby : [];
    leisureData.value = {
      labels: LEISURE_ORDER.map((label) => LEISURE_DISPLAY_BY_LABEL[label] || label),
      datasets: [bar(
        "จำนวน",
        "#9dbaf0",
        LEISURE_ORDER.map((label) => toNumber(hobbyItems.find((item) => (item?.value ?? "") === label)?.count ?? 0)),
        { barPercentage: 0.7, categoryPercentage: 0.8 }
      )],
    };

    const futureEdu = Array.isArray(data.future_education) ? data.future_education : [];
    studyLevel.value = {
      labels: futureEdu.map((item) => item?.value ?? ""),
      series: futureEdu.map((item) => toNumber(item?.count ?? 0)),
    };
  }
};

onMounted(() => {
  fetchOverview();
  fetchRiskSupport();
  fetchFamily();
  fetchFuture();
});

watch(filterParams, () => {
  fetchOverview();
  fetchRiskSupport();
  fetchFamily();
  fetchFuture();
}, { deep: true });

const attitudeOptions = (() => {
  const opts = barOptions({ legend: true, stacked: true, aspectRatio: 1.1 });
  opts.scales.y.title = { display: true, text: "คน", font: { size: 12 } };
  return opts;
})();
</script>
